
import constants        from '../../constants/Constants.js';
import {Maybe}          from 'monet';
import saveHelperService    from '../SaveHelperService.js';
import Immutable        from 'immutable';
import mobileConstants from '../../mobile/commons/MobileFormsConstants.js';
import utilMobile from '../../mobile/commons/MobileGeneralFunctions.js';
import _ from 'lodash';
import util from 'util/Util.js';
import mobileListService from './MobileListService.js';

import {prepareSectionAttributesForLegacySave} from '../../components/MobileWizard/utils/mobileUtils.js'

const pagePropAdditions = {
    "_preloadImage" :  "true",
    "_hasTitle" :  "false",
    "_titleColor" :  "FFFFFF",
    "_accessDesc" :  "",
    "_titleFont" :  "verdana, 10",
    "_master" :  "no",
    "_tabEnabled" :  "false",
    "_masterCtrl" :  "",
    "_backgroundColor" :  "FFFF99",
    "_transparency" :  "1",
    "_obligatoryMessage" :  "",
    "_accessSilent" :  "false",
    "_titleBackgroundColor" :  "0099FF",
    "_backgroundImageStyle" :  "center",
    "_border" :  "1, solid",
    "_titleHeight" :  "20",
    "_borderColor" :  "333333",
    "_titleAlign" :  "left",
    "_transparentBackground" :  "false",
    "_toolTip" :  "",
    "_padding" :  "0",
    "_titleText" :  ""
};

// We filter-include these
const pagePropInclusions = Immutable.Set([
    'padding', 'backgroundColor', 'transparentBackground', 'titleText', 'border', 'backgroundImageAssetId',
    'borderColor', 'preloadImage', 'hasTitle', 'accessDesc', 'titleColor', 'zOrder', 'titleFont',
    'transparency', 'obligatoryMessage', 'tabEnabled', 'accessSilent', 'masterCtrl', 'backgroundImageStyle',
    'master', 'titleBackgroundColor', 'titleHeight', 'toolTip', 'titleAlign', 'width', 'height'
]);

const objectsWithListOfItems = Immutable.Set([
    'control_list', 'control_drop_down'
]);

const objectsWithoutHeight = Immutable.Set([
    'control_table', 'control_ranking', 'control_websignature', 'control_captcha'
]);

const objectsWithNoWidthAndHeight = Immutable.Set([
    'control_picture'
]);

const objectsWithHeightAuto = Immutable.Set([
    'control_small_heading', 'control_small_text', 'control_medium_heading', 
    'control_large_heading', 'control_text', 'control_ranking', 'control_bullet_text','control_button',
    'control_page_button', 'control_play_form_button', 'control_play_report_button',
    'control_print_button', 'control_submit_button'
]);

const objectsWith100Width = Immutable.Set([
    'control_group', 'control_checkbox_group', 'control_radio_button_group'
]);


const controlPropertiesAllowedInMobile = Immutable.Set([
    'width', 'height', 'font', 'margins', 'textStyle', 'textColor', 'fontSize', 'fontFamily', 'textWeight', 
    'borderColor', 'border', 'backgroundColor', 'align', 'bgGradientColor', 'buttonStyle', 'backgroundDownColor', 'bgGradientDownColor',
    'cornerRadius', 'buttonFont', 'buttonTextColor', 'buttonBackgroundColor', 'buttonBackgroundGradientColor', 'imageBackgroundColor', 
    'signatureColor', 'signatureThickness', 'tickColor', 'tickInterval', 'sliderColor', 'barColor', 'label', 'showLabel', 'length',
    'maintainAspectRatio', 'stretch', 'lineColor','headerFont', 'headerHeight', 'webFont'
]);

const pagePropertiesAllowedInMobile = Immutable.Set([
    'width', 'height', 'backgroundColor'
]);

const groupMobileDefaultProperties = {
    _hasTitle : 'false',
    _border : '1, none, 0',
    _backgroundColor : 'ffffff',
    _transparentBackground : 'true'
};

class MobileSaveService {

    marshalMobileViews( listService ) {
        const viewsRoot = function(f) {
            const fb = listService.formBase;
            f.Form = {};
            f.Form._id = fb.id;
            f.Form._name = fb.name;
            return Maybe.fromNull(f);
        };

        const formGuid = function (f) {
            f.Form._guid = listService.formBase.guid;
            return Maybe.fromNull(f);
        };

        // "_docVersion": "0",
        const formDocVersion = function (f) {
            f.Form._docVersion = listService.formBase.docVersion;
            return Maybe.fromNull(f);
        };

        // "_version": "0.1",
        const formVersion = function (f) {
            f.Form._version = listService.formBase.version;
            return Maybe.fromNull(f);
        };

        const formProperties = function (f) {

            const form = mobileListService
                ._mobileObjMap
                .find(control => control.model.get('factoryKey') === "layout_frame");

            const _outsideColor = form && form.model.get('mobileOutsideColor')
                                        ? form.model.get('mobileOutsideColor').substr(1) : 'eeeeee';
            f.Form.Properties = { _width: '100%', _height: '100%', _outsideColor: _outsideColor };

            const maxAppWidth = form && form.model.get('maxAppWidth') ? form.model.get('maxAppWidth') : '650';
            if (maxAppWidth !== undefined && maxAppWidth !== null) {
                f.Form.Properties._maxAppWidth = maxAppWidth;
            }

            return Maybe.fromNull(f);
        };

        const pages = function (f) {
            const root = listService.docType === constants.DOC_TYPE_REPORT ? 'Report' : 'Form';

            const pp = f[root].Pages = {};
            const pa = pp.Page = [];
            
            if(listService._mobilePages && listService._mobilePages.size){
                listService._mobilePages.forEach( (v) => {
                    const p = {};
                    p._id = listService.getCleanedId(v.id);
                    p._name = v.name;
                    pa.push(p);
                });
            }

           return Maybe.fromNull(f);
        };

        const sections = function(f){
           const root = listService.docType === constants.DOC_TYPE_REPORT ? 'Report' : 'Form';

           const pp = f[root].Sections = {};
           const pa = pp.Section = [];

           if (listService._mobileSections && listService._mobileSections.size) {
               listService._mobileSections.forEach( (v) => {
                   const p = {};
                   p._id = v.id;
                   p._name = v.name;
                   p._columnId = v.columnId;
                   p._pageId = listService.getCleanedId(v.pageId);
                   p._index= v.index;
                   //p.Properties ={_fontSize:v.attributes.fontSize};
                   pa.push(p);
               });
           }

           return Maybe.fromNull(f);
        };

        const columns = function(f){
            const root = listService.docType === constants.DOC_TYPE_REPORT ? 'Report' : 'Form';
 
            const pp = f[root].Columns = {};
            const pa = pp.Column = [];

            if (listService._mobileColumns && listService._mobileColumns.size) {
                listService._mobileColumns.forEach( (v) => {
                    const p = {};
                    p._id = v.id;
                    p._name = v.name;
                    p._pageId = listService.getCleanedId(v.pageId);
                    p._order = v.order;
                    pa.push(p);
                });
            }
 
            return Maybe.fromNull(f);
         };

         

        const objectsHelper = function( parent, parentId, pageId) {

            const objs = parent.Object = [];

            if(listService._mobileObjects && listService._mobileObjects.size && listService.mobileSectionsExist()){
                listService._mobileObjects
                    .filter(control => control.sectionId && control.sectionId === parentId && !control.isHidden && (!control.groupId))
                    .sort((a, b) => (a?.order || 0) - (b?.order || 0))
                    .forEach(control => {
                        
                        let controlView = mobileListService.getMobileControl(control.id);

                        if(!controlView){
                            controlView = listService.getObject(control.id);
                        }

                        //Deep Cloning object
                        const clonedObject = {...controlView};
                        //Cloning backbone's model
                        clonedObject.model = controlView.model.clone();
                        
                        const objOut = saveHelperService.configureObjectOut(clonedObject, true);

                        if(objectsWithListOfItems.contains(control.factoryKey)){
                            delete objOut.Properties.Property;
                        }else  if(control.factoryKey === 'control_table'){
                            delete objOut.Columns;
                        }

                        for (let key in objOut.Properties) {
                            if(!controlPropertiesAllowedInMobile.contains(key.replace('_',''))){
                                delete objOut.Properties[key];
                            }
                            else {
                                let value = objOut.Properties[key]; //Remove any trailing 'px' values
                                if (typeof value === 'string' && value.includes('px')) {
                                    objOut.Properties[key] = value.replace(/px/gi, ''); 
                                }
                            }
                        }

                        objOut.Properties._order = control.order;
                        objOut.Properties._isNew = control.isNew;
                        objOut.Properties._width = 'auto';
                        objOut.Properties._height = Math.ceil(util.extractNum(!mobileListService.mobileObjMapHasObjects() ? control.height : controlView.model.get('height')));
                       
                        if (objectsWithHeightAuto.contains(control.factoryKey)){
                            objOut.Properties._height = 'auto';
                        }

                        //PF-5605 mobile groups should have 100% width for correct display on player
                        if(objectsWith100Width.contains(control.factoryKey)){
                            objOut.Properties._width = '100%';
                        }
                        
                        if (objectsWithNoWidthAndHeight.contains(control.factoryKey)){
                            delete objOut.Properties._width;
                            delete objOut.Properties._height;
                        }

                        if(objectsWithoutHeight.contains(control.factoryKey)){
                            delete objOut.Properties._height;
                        }

                        if (constants.GROUP_KEYS.contains(control.factoryKey)) {
                            // loop through childList Models , retrieve the views and process
                            saveHelperService.mobileObjectsHelperGroups(objOut, pageId);
                            $.each(objOut.Objects.Object, function(_idx, _objOut){
                                delete _objOut._name;
                            });

                            //PF-5480 apply default properties to groups
                            if (!objOut.Properties){
                                objOut.Properties = {};
                            }

                            objOut.Properties = { ...objOut.Properties, ...groupMobileDefaultProperties } ;
                        }

                        objs.push(objOut);

                    });
            }
        };

        const columnObjectsHelper = function( parent, parentId, order, twoColumns, mainColumn) {

            parent.Objects = {};
            const column = listService.getColumn(parentId, order);

            parent._id = (column) ? column.id : '';
            parent._type = 'column';
            parent._name = (column) ? column.name : '';
            parent._showOnMobile = true;
            parent._order = (column) ? column.order : 0;
            parent._pageId = listService.getCleanedId(parentId);
            const obj = parent.Objects.Object = [];
            let newIndexes = undefined;
            if(twoColumns){
                newIndexes = utilMobile.reorganizeIndex(parentId, mainColumn);
            }

            if (listService._mobileSections && listService._mobileSections.size) {
                
                listService._mobileSections
                    .filter(section => section.pageId && section.pageId === parentId)    
                    .forEach( (section) => {
                        // Object for sections
                        let mobileSection = mobileListService.getMobileControl(section.id);

                        const secObj = {};
                        secObj._id = section.id;
                        const parentId = section.id;
                        const pageId = section.pageId;
                        secObj._type = 'section';
                        secObj._name = section.name;
                        secObj._pageId = listService.getCleanedId(pageId);

                        secObj._columnId = section.columnId;
                        
                        let mobileProps = {};
                        
                        const wizardAttributes = mobileSection ? mobileSection.model.attributes : section.attributes;
                        mobileProps = prepareSectionAttributesForLegacySave(wizardAttributes);                            

                        secObj.Properties = Object.assign({ _name:  listService.isMobileOpen ? section.name : mobileSection && mobileSection.model ? mobileSection.model.get('titleText') : section.name,
                            _twoColumns: twoColumns,
                            _index: section.index,
                            _column: utilMobile.getColumnNumberBySection(section.id, section.pageId)
                        }, mobileProps);

                        if(newIndexes && newIndexes.size){
                            const sectionFiltered = newIndexes.get(section.id);
                            if(sectionFiltered){
                                secObj.Properties._indexTwoColumn = sectionFiltered.index;
                            }
                        }
                        obj.push(secObj);
                
                        // Drill-down: controls on current page object.
                        // Each control has a pageId; it is equal to the pageId above
                        secObj.Objects = {}; 
                        const parent2 = secObj.Objects;
                        objectsHelper( parent2, parentId, pageId );
                });
            }
        };


        const hiddenObjectsHelper = function(parent, parentId) {
            parent.Objects = {};
            parent._id = '';
            parent._type = 'group';
            parent._name = 'hidden controls';
            parent._showOnMobile = false;
            parent._order = -1;
            parent._pageId = listService.getCleanedId(parentId);
            parent.Properties = {};

            const objs = parent.Objects.Object = [];

            //loop through objects on page, excluding any that belong to Groups
            if(listService._mobileObjects && listService._mobileObjects.size){
                listService._mobileObjects
                    .filter(control => control.pageId && control.pageId === parentId && control.isHidden && (!control.groupId))
                    .sortBy((control) => -control.tabIndex)
                    .reverse()
                    .forEach(control => {
                        const controlView = listService.getObject(control.id);
                        controlView.model.set({
                            isNew: control.isNew
                          }, { silent: true });

                        const objOut = saveHelperService.configureObjectOut(controlView, true);

                        if (constants.GROUP_KEYS.contains(control.factoryKey)) {
                            // loop through childList Models , retrieve the views and process
                            saveHelperService.objectsHelperGroups(objOut, parentId);
                        }

                        objs.push(objOut);

                    });
            }
        };
        
        const objects = function (f) {
            const root = listService.docType === constants.DOC_TYPE_REPORT ? 'Report' : 'Form';
            const objs = f[root].Objects = {}; 
            const obj = objs.Object = [];       
        
            if(listService._mobilePages && listService._mobilePages.size && listService.mobileSectionsExist()){
                listService._mobilePages.forEach( (p) => {
                    // Object for a page
                    const pageView = listService.getPage(p.id);
                    const pageObj = {};
                    pageObj._id = listService.getCleanedId(pageView.model.get('id'));
                    const pageId = pageView.model.get('id');
                    pageObj._type = 'group';
                    pageObj._name = pageView.model.get('name');
                    obj.push(pageObj);

                    const pgProps = pageObj.Properties = {...pagePropAdditions};
                    Immutable.List(pageView.model.keys())
                        .filter( k => pagePropInclusions.includes( k ) )
                        .forEach( k1 => {
                            let val = pageView.model.get(k1);

                            if (k1 === 'width' || k1 === 'height') {
                                val = '100%';
                            }

                            if (val && k1.toLowerCase().includes('color')) {
                                val = val.replace('#','');
                            }

                            const key = `_${k1}`;
                            pgProps[key] = val;
                        });
                    
                    for (let key in pgProps) {
                        if(!pagePropertiesAllowedInMobile.contains(key.replace('_',''))){
                            delete pgProps[key];
                        }
                    }
                    
                    
                    const twoColumns = listService.existSecondColumnConfigurationByPage(pageId);
                    const column = utilMobile.getMainColumn(pageId, twoColumns);
                    pageObj.Properties._twoColumns = twoColumns;
                    pageObj.Properties._mainColumn = column.mainColumn;
                    pageObj.Properties._maxHeight = column.maxHeight;
                    pageObj.Properties._backgroundColor = 'EEEEEE';

                    pageObj.Objects = {};
                    pageObj.Objects.Object = [{},{}];
                    //Column
                    columnObjectsHelper(pageObj.Objects.Object[0], pageId, 0, twoColumns, column.mainColumn);
                    //hidden Controls
                    hiddenObjectsHelper(pageObj.Objects.Object[1], pageId);
                });
            }
            return Maybe.fromNull(f);
        };

        const mobileForm = { };

        const mobileObj =  Maybe.fromNull( mobileForm )
            .chain( viewsRoot )
            .chain( formGuid )
            .chain( formDocVersion )
            .chain( formVersion )
            .chain( formProperties )
            .chain( pages )
            .chain( sections )
            .chain( columns )
            .chain( objects )
            .toEither( )
            .cata( ( ) => Nothing, f  =>  f );
            
        return mobileObj;

}

    createMobileSettings(listService){

        const styles = function(node){
            const objStyles = node.Settings.MobileGlobalStyles = {};
            const style = objStyles.ControlStyle = [];

            listService._mobileStyles.map((element, key) => {
                const param = {};
                param._id = element.id;
                param._name = key;
                param.factoryKey = key;
                if (key === mobileConstants.MARGIN_KEY) {
                    param.marginSize = element.marginSize;
                    param.defaultMargin = element.defaultMargin;
                }
                param.fontSize = element.fontSize;
                param.fontStyle = element.fontStyle;
                param.fontWeight = element.fontWeight;
                param.textAlign = element.textAlign;
                param.height = element.height;
                style.push(param);
            });

            return Maybe.fromNull(node);
        };

        const currentStep = function(node) {
            node.Settings = {};
            node.Settings.CurrentStep = {};
            node.Settings.CurrentStep._value = listService.mobileCurrentStep;
            return Maybe.fromNull(node);
        };

        const mobileTimesWizardCompleted = function(node) {
            node.Settings.mobileTimesWizardCompleted = {};
            node.Settings.mobileTimesWizardCompleted._value = listService.timesWizardCompleted;
            return Maybe.fromNull(node);
        };

        const topLevelStyles = function (node) {

            const propertiesToSync = ['maxAppWidth', 'fontFamily', 'marginSpacing'];

            propertiesToSync.forEach(propName => {
                const value = listService._mobileSettings.get(propName);
                if (value !== undefined && value !== null) {
                    node.Settings[propName] = value;
                }
            });

            return Maybe.fromNull(node);
        };


        const mobileSettings = { };

        const settingsObj =  Maybe.fromNull( mobileSettings )
            .chain( currentStep )
            .chain( topLevelStyles )
            .chain( styles )
            .chain( mobileTimesWizardCompleted )
            .toEither( )
            .cata( ( ) => Nothing, f  =>  f );
        return settingsObj;
    }

    createMobileTwoColumn(listService){
        
        const viewsRoot = function(f) {
            const formBase = listService.formBase;
            f.Form = {};
            f.Form._id = formBase.id;
            f.Form._name = formBase.name;
            return Maybe.fromNull(f);
        };

        const formGuid = function (f) {
            f.Form._guid = listService.formBase.guid;
            return Maybe.fromNull(f);
        };

        const formDocVersion = function (f) {
            f.Form._docVersion = listService.formBase.docVersion;
            return Maybe.fromNull(f);
        };

        const formVersion = function (f) {
            f.Form._version = listService.formBase.version;
            return Maybe.fromNull(f);
        };

        const pages = function (f) {
            const root = listService.docType === constants.DOC_TYPE_REPORT ? 'Report' : 'Form';

            const pagesByForm = f[root].Pages = {};
            const listOfPages = pagesByForm.Page = [];
            
            const pagesId = listService._mobileColumns.filter( c => c.name === mobileConstants.SECOND_COLUMN_NAME).map( a=> a.pageId).toArray();
            const pages = listService._mobilePages.filter(p => pagesId.includes(p.id) );

            if(pages && pages.size){
                pages.forEach( (page) => {
                    const newPage = {};
                    newPage._id = listService.getCleanedId(page.id);
                    newPage._name = page.name;
                    listOfPages.push(newPage);
                });
            }

           return Maybe.fromNull(f);
        };

        const sections = function(f){
           const root = listService.docType === constants.DOC_TYPE_REPORT ? 'Report' : 'Form';

           const pageSections = f[root].Sections = {};
           const listOfSections = pageSections.Section = [];
           
           const pagesId = listService._mobileColumns.filter(column => column.name === mobileConstants.SECOND_COLUMN_NAME).map(column2 => column2.pageId).toArray(); 
           const columns = listService._mobileColumns.filter(column => pagesId.includes(column.pageId) && column.order !== 0 );

           if (columns && columns.size) {
                columns.forEach( (column) => {
                    if(column.sections){
                        column.sections.forEach( (section) => {
                            const newSection = {};
                            newSection._id = section.id;
                            newSection._columnId = column.id;
                            newSection._order = section.order;
                            listOfSections.push(newSection);
                        });
                    }
                });
           }

           return Maybe.fromNull(f);
        };

        const columns = function(f){
            const root = listService.docType === constants.DOC_TYPE_REPORT ? 'Report' : 'Form';
 
            const pageColumns = f[root].Columns = {};
            const listOfColumns = pageColumns.Column = [];
            
            const pagesId = listService._mobileColumns.filter(column => column.name === mobileConstants.SECOND_COLUMN_NAME).map(column2 => column2.pageId).toArray();
            const columns = listService._mobileColumns.filter(column => pagesId.includes(column.pageId) && column.order !== 0 );
           
            if (columns && columns.size) {
                columns.forEach( (column) => {
                        const newColumn = {};
                        newColumn._id = column.id;
                        newColumn._name = column.name;
                        newColumn._pageId = listService.getCleanedId(column.pageId);
                        newColumn._order = column.order;
                        listOfColumns.push(newColumn);
                });
            }

            return Maybe.fromNull(f);
         };        

        const configColumns = { };

        const mobileObj =  Maybe.fromNull( configColumns )
            .chain( viewsRoot )
            .chain( formGuid )
            .chain( formDocVersion )
            .chain( formVersion )
            .chain( pages )
            .chain( columns )
            .chain( sections )
            .toEither( )
            .cata( ( ) => Nothing, f  =>  f );
              
        return mobileObj;
    }

}
const mobileSaveService = new MobileSaveService();
export default mobileSaveService;